__turbopack_context__.v({
  "account": "_0gmVvq_account",
  "container": "_0gmVvq_container",
  "icon": "_0gmVvq_icon",
  "iconSpinner": "_0gmVvq_iconSpinner",
  "iconWithLabel": "_0gmVvq_iconWithLabel",
  "signIn": "_0gmVvq_signIn",
});
